import { render, staticRenderFns } from "./UserBond.vue?vue&type=template&id=4ed8e563&scoped=true"
import script from "./UserBond.vue?vue&type=script&lang=js"
export * from "./UserBond.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed8e563",
  null
  
)

export default component.exports